const CheckedIcon = function CheckedIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="14" height="14" rx="7" fill="#1EC252" stroke="#1EC252" strokeWidth="2" />
      <path d="M11.8299 4C10.1395 5.74267 8.18579 7.74701 6.43782 9.54701L3.54158 7.01897L2.40063 8.39585L5.91123 11.4656L6.53106 12.0017L7.10153 11.4148C8.97244 9.48601 11.1958 7.20705 13.0695 5.2753L11.8299 4V4Z" fill="white" />
    </svg>
  );
};
export default CheckedIcon;
